import { render } from "./MonthlyTwo.vue?vue&type=template&id=6d962b1b"
import script from "./MonthlyTwo.vue?vue&type=script&lang=js"
export * from "./MonthlyTwo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__